/* GENERATED by scripts/merge-i18n.js - do not edit. Content hash of the merged i18n bundles. */
export const I18N_VERSION = 'b289d4bb'
